module.exports = __webpack_public_path__ + "44cc39a25e512c1dc89b989d91ffc40b.pdf";